import { useEffect, useState } from 'react';

/**
 * Keeps a component mounted for `durationMs` after it is closed, so its exit
 * animation has something to play on. Without this an element that returns null
 * when closed vanishes on the frame it closes, and only the entrance ever runs.
 */
export function useDeferredUnmount(open: boolean, durationMs: number): boolean {
  const [mounted, setMounted] = useState(open);

  useEffect(() => {
    if (open) {
      setMounted(true);
      return;
    }
    const timer = setTimeout(() => setMounted(false), durationMs);
    return () => clearTimeout(timer);
  }, [open, durationMs]);

  return mounted;
}
